var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextGenOncologists(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.214,
    height: 150,
    viewBox: "0 0 135.214 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.214,
    height: 150,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.869,40.292c13.809,17.013,28.17,30.38,29.275,44.962,1.1,14.472-11.047,30.159-24.967,42.532-13.809,12.483-29.5,21.763-45.4,22.2-16.018.332-32.257-8.285-44.188-20.768A74.8,74.8,0,0,1,.148,82.934C-.957,65.48,4.124,46.81,15.945,29.908,27.765,12.9,46.435-2.35,62.454.3c16.128,2.541,29.5,23.089,43.415,39.991",
    fill: "#0af"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M56.231,52.794c.627-.378,1.281-.735,1.948-1.072.991-.519,1.995-.977,2.952-1.368h0A17.8,17.8,0,0,1,51.9,37.1a2.341,2.341,0,0,0-2.326-2.042h-.013a2.344,2.344,0,0,0-2.332,2.622A22.235,22.235,0,0,0,56.231,52.794Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.034,84.336a15.079,15.079,0,0,0,3.383-5.573H55.794a14.955,14.955,0,0,0,3.386,5.573Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.07,65.917H59.176a11.516,11.516,0,0,0-3.385,5.842H79.419a11.209,11.209,0,0,0-3.35-5.842Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.842,44.92a14.661,14.661,0,0,0,4.389-5.573H55.981A15.228,15.228,0,0,0,59.7,44.92Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.076,105.334a10.668,10.668,0,0,0-4.133,5.842H79.266a11.379,11.379,0,0,0-3.709-5.842Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.333,92.773c.641-.391,1.308-.748,1.982-1.085a29.908,29.908,0,0,1,2.972-1.342A17.635,17.635,0,0,1,51.77,74.964c0-7.314,4.967-13.832,12.1-16.568,2.345-.9,4.935-.846,7.322-1.628a26.61,26.61,0,0,0,10.973-6.9,21.943,21.943,0,0,0,5.818-12.261,2.357,2.357,0,0,0-4.678-.573c-1,7.833-7.692,12.147-12.059,14.155-3.094,1.423-6.635,1.675-9.786,3.059a25.6,25.6,0,0,0-8.422,5.839,21.756,21.756,0,0,0-5.979,14.877,22.067,22.067,0,0,0,9.269,17.809Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.967,97.187c-.135.088-.27.168-.411.249-.532.317-1.058.6-1.577.856-.237.122-1.4.681-2.933,1.322a17.806,17.806,0,0,1,9.269,13.279,2.332,2.332,0,0,0,2.325,2.042h.007a2.348,2.348,0,0,0,2.339-2.622A22.248,22.248,0,0,0,78.967,97.187Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.092,98.617a39.706,39.706,0,0,1,5.454-1.382,31.123,31.123,0,0,0,5.8-2.265A23.949,23.949,0,0,0,83.3,88.587,21.578,21.578,0,0,0,88.15,75.031a22.071,22.071,0,0,0-9.269-17.815c-.647.4-1.314.762-2,1.1-.385.195-1.463.741-2.939,1.334a17.641,17.641,0,0,1,9.5,15.383c0,7.4-5.426,14.445-12.436,16.715-1.937.627-4.07.66-5.986,1.237h0a26.95,26.95,0,0,0-11.972,7.137,21.942,21.942,0,0,0-5.817,12.261,2.349,2.349,0,0,0,4.665.559c.984-8.291,7.819-12.477,12.2-14.323Z",
    fill: "#2b528e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextGenOncologists);
export default __webpack_public_path__ + "static/media/next-gen_oncologists.98ffd36a05ed6ccb5e14a1d6a654c934.svg";
export { ForwardRef as ReactComponent };